<div class="loader_father">
  <span class="loader"></span>
</div>